import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

import App from './App';
import { store } from './redux/store';
import routes from './routes';

import './styles/index.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-phone-input-material-ui/lib/material.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter(routes, { basename: '/dashboard' });

root.render(
  <Provider store={store}>
    <App>
      <RouterProvider router={router} />
    </App>
  </Provider>,
);

// Learn more report-web-vitals: https://bit.ly/CRA-vitals
reportWebVitals();
